import * as adjustList from '../services/adjustList';

export default {
  namespace: 'adjustList',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
    allTotal: 0,
  },

  effects: {
    *getMemberList({ payload: { values } }, { call, put }) {
      const response = yield call(adjustList.getMemberList, values);
      yield put({
        type: 'save',
        payload: {
          memberPageList: response?.data,
        },
      });
    },

    *getMemberListNum({ payload: { values } }, { call, put }) {
      const response = yield call(adjustList.getMemberList, values);
      yield put({
        type: 'save',
        payload: {
          allTotal: response?.data?.total,
        },
      });
    },
    //获取门店列表
    *getStoreList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(adjustList.getStoreList, values);
      yield put({
        type: 'save',
        payload: {
          storeList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    //获取总数据条数
    *getTotalData({ payload: { values }, callback }, { call, put }) {
      const response = yield call(adjustList.getTotalData, values);
      yield put({
        type: 'save',
        payload: {
          totalData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    *getLevels(_, { call, put }) {
      const response = yield call(adjustList.getLevels);
      yield put({
        type: 'save',
        payload: {
          levels: response?.data,
        },
      });
    },

    *addMember({ payload: { values }, callback }, { call, put }) {
      const response = yield call(adjustList.addMember, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addMember: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
